<template>
    <div class="expressBox">
        <span class="closeBtn" @click="returnBtn"></span>
        <header>{{ $t("expressProposalWall") }}</header>
        <ul class="contentBox">
            <li class="contentItem">
                <p class="contentTitle">{{ $t("expressHowTo") }}</p>
                <div class="contentBody">{{ $t("expressSend") }}</div>
                <div class="contentImg">
                    <img src="../../assets/express/bodyImg.png" alt="">
                </div>
                <div class="contentBody">{{ $t("expressSend1") }}</div>
                <div class="contentBody">{{ $t("expressSend2") }}</div>
                <div class="contentBody">{{ $t("expressSend3") }}</div>
            </li>
            <li class="contentItem">
                <p class="contentTitle">{{ $t("expressDifferent") }}</p>
                <div class="contentBody">{{ $t("expressWeHave") }}</div>
                <div class="contentBody">{{ $t("expressWeHave1") }}</div>
                <div class="contentBody">{{ $t("expressWeHave2") }}</div>
                <div class="contentBody">{{ $t("expressWeHave3") }}</div>
                <div class="contentBody">{{ $t("expressWeHave4") }}</div>
            </li>
            <li class="contentItem">
                <p class="contentTitle">{{ $t("expressProposal") }}</p>
                <div class="contentBody">{{ $t("expressProposal1") }}</div>
                <div class="contentBody">{{ $t("expressProposal2") }}</div>
            </li>
        </ul>
    </div>
   
  </template>
  
  <script>
  export default {
    name: "express",
    data() {
      return {
        langType: "",
        client:''
      };
    },
    created() {
        this.langType = this.$route.query.langType;
        this.language()
        this.judgeClient()
    },
    mounted() {
    },
    methods: { 
        // 关闭webview半开
        returnBtn() {
            this.$completes.complete("getPreviousPage");
        },
        // 判断平台
        judgeClient() {
        if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) { //判断iPhone|iPad|iPod|iOS
            this.client = 'iOS';
        } else if (/(Android)/i.test(navigator.userAgent)) { //判断Android
            this.client = 'Android';
        } else {
            this.client = 'PC';
        }
        return this.client;
        },
        language() {
            let langs = this.langType.substring(0, 2);
            let lang = this.langType;
            if (langs == "zh") {
                if (lang == "zh_TW" || lang == "zh_HK") {
                this.$i18n.locale = "tc";
                } else {
                this.$i18n.locale = "zh";
                }
            } else if (langs == "en") {
                this.$i18n.locale = "en";
            } else if (langs == "ar") {
                this.$i18n.locale = "ar";
            }else if (langs == "tr") {
                this.$i18n.locale = "tr";
            } else if (langs == "es") {
                this.$i18n.locale = "es";
            } else if (langs == "pt") {
                this.$i18n.locale = "pt";
            } else {
                this.$i18n.locale = "en";
            }
            document.title = this.$t('prettyNumber.title')
             document.querySelector("html").setAttribute("lang", this.$i18n.locale);
        },
    },
  };
  </script>
  
  <style scoped>
  html[lang="ar"] .cancelBox {
  -webkit-transform: rotateY(180deg);
}
html[lang="ar"] .cancelBox ul {
  -webkit-transform: rotateY(180deg);
}

html[lang="ar"] .body {
  direction: rtl;
}

html[lang="ar"] .pay {
  direction: rtl;
}
  * {
    margin: 0;
    padding: 0;
  }
  .expressBox{
    width: 640px;
    height: 1000px;
    /* padding: 0.4rem 0.28rem; */
    padding-top: 28px;
    box-sizing: border-box;
    font-family: 'Montserrat';
    background: url('../../assets/express/bg.png') no-repeat;
    background-size: 640px 1000px;
    position: relative;
    overflow: auto;
  }
  .expressBox::-webkit-scrollbar {
        display: none;
    }
    .expressBox {
        scrollbar-width: none; 
    }
  .expressBox header{
    font-size: 30px;
    height: 48px;
    line-height: 48px;
    color: #fff;
    text-align: center;
    font-weight: 600;
  }
  .closeBtn{
    position: absolute;
    top: 28px;
    right: 24px;
    width: 40px;
    height: 40px;
    background: url('../../assets/express/close.png') no-repeat;
    background-size: 40px 40px;
    display: none;
  }
  .contentItem{
    width: 592px;
    padding: 24px;
    margin: 0 auto 28px;
    box-sizing: border-box;
    border-radius: 20px;
    color: rgba(0,0,0,0.85);
    background-color: rgba(255, 255, 255, 0.45);
  }
  .contentBox{
    margin-top: 20px;
    /* height: 900px; */
    border-radius: 20px;
    overflow: scroll;
  }
  
  .contentTitle{
    font-size: 26px;
    line-height: 34px;
    margin-bottom: 20px;
    font-weight: 500;
  }
  .contentBody{
    font-size: 24px;
    line-height: 36px;
    font-weight: 400;
    margin-bottom: 10px;
  }
  .contentImg img{
    display: block;
    width: 544px;
    height: 416px;
    margin: 12px auto 24px;
    border-radius: 16px;
  }
  </style>
  